import { useState } from "react";
import instance from "~/utils/i18n";
import { Switch } from "~/common/components/Switch/Switch";

export const DebugLanguageToggle = ({ language }: { language: string }) => {
  const [debugEnabled, setDebugEnabled] = useState(false);

  return (
    <div className="scha__header__language-toggle">
      <Switch
        checked={debugEnabled}
        onChange={(event, value) => {
          setDebugEnabled(value);
          instance.changeLanguage(value ? "cimode" : language);
        }}
      />
    </div>
  );
};
